import { Component } from '@angular/core';
import { NavController , NavParams,IonicPage } from 'ionic-angular';
import {DataProvider} from '../../providers/data/data';
import { ExhibitionPage } from '../../pages/exhibition/exhibition';
import { SpotPage } from '../../pages/spot/spot';
import { SpotsListPage } from '../../pages/spots-list/spots-list';
import { DomSanitizer } from '@angular/platform-browser';
import { ExhibitionListPage } from '../exhibition-list/exhibition-list';

@IonicPage({
  name: 'muzeum',
  segment: 'muzeum/:muzeum'
})
@Component({
  selector: 'page-muzeum',
  templateUrl: 'muzeum.html'
})
export class MuzeumPage {
  lang; 
  showBack=true;
  muzeum;
  MuzeumData={
    name:'',
    discription:'',
    ExhibitionStyle:''
  };
  backGroundCove="";

  id;
  urlCode;
  exhibition;
  spots:any;
  oneExID:any;
  Exhibitions;
  multiExe=false;
  loaderPage = false;
  loaderPageDisplayNone = false;
  oneExe = false;
  constructor(private sanitizer: DomSanitizer,public navCtrl: NavController, public navParams:NavParams, private _DataProvider:DataProvider) {
    if(this.navParams.get('muzeum') && !this._DataProvider.getLocalStorage('muzeum')){

      this._DataProvider.setLocalStorage('muzeum',this.navParams.get('muzeum'));

    }else{
      if(!this.navParams.get('muzeum') && !this._DataProvider.getLocalStorage('muzeum')){
      this.navCtrl.setRoot("Welcome")

      }
    }
    if(!this._DataProvider.getLocalStorage('lang')){

      this._DataProvider.setLocalStorage('lang',"he");

    }
    
    this.lang = this._DataProvider.getLocalStorage('lang');
    this.muzeum = this._DataProvider.getLocalStorage('muzeum');
    console.log('this._DataProvider.getLocalStorage(lang)',this._DataProvider.getLocalStorage('lang'));
    console.log('this._DataProvider.getLocalStorage(muzeum)',this._DataProvider.getLocalStorage('muzeum'));

    this._DataProvider.navigationC.home = true;
    this._DataProvider.navigationC.more = false;
    this._DataProvider.navigationC.numType = false;


  }
  cssEX:any = '';





  ionViewDidEnter() {
    this._DataProvider.currentPage = 'muzeum'



    this._DataProvider.showPad = false;
    this._DataProvider.menuShow = false;
    this._DataProvider.mapShow = false;
    this._DataProvider.NowLang= this.lang;
    this.muzeum = this._DataProvider.getLocalStorage('muzeum');
    // console.log(this.muzeum);

    if(this.muzeum){
    this._DataProvider.getMuzeumByurlCodeFB(this.muzeum).subscribe((res:any) => {
      console.log("res",res);
      console.log(res[0]);
      this._DataProvider.Muzeum = res[0];
     this._DataProvider.backGroundCove=res[0].background;
     this.backGroundCove=res[0].background;


      if(res[0].settings.css){
        this.cssEX = ` <style>`;
        this.cssEX += res[0].settings.css;
        this.cssEX += ` </style>`;
        this.cssEX = this.sanitizer.bypassSecurityTrustHtml(this.cssEX);
        console.log('CSS--------',this.cssEX);
    
      }

      this.MuzeumData = this._DataProvider.getMuzeumData(this.lang);
      console.log('FB - Muzeum._id', this._DataProvider.Muzeum);
      console.log('FB - this.lang', this.lang);
      

     // this._DataProvider.getExhibitionByLang(this._DataProvider.Muzeum.id,this.lang)
      this._DataProvider.getExhibitionByLangFB(this._DataProvider.Muzeum.id,this.lang)
      .subscribe(res => {
        console.log(res);
        this.Exhibitions = res;
        this._DataProvider.ExhibitionsService= res;
        if(this._DataProvider.Muzeum.settings.type == 'oneExe'){
          this.Exhibitions = res;
          this.oneExe = true;
          // get spost
          let self = this;
          console.log('this.id--:',this.id);
          this.oneExID = res[0].id;
          console.log('this.oneExID--:',this.oneExID);

          this._DataProvider.getSpotsByExhibitionIDFB(this.oneExID)
          .subscribe(res => {
            console.log(res);
            self.spots = res;
            self._DataProvider.spotsList = res;
            self.loaderPage = true;
            setTimeout(() => {
              self.loaderPageDisplayNone = true;
            }, 1300);
        console.log(self.spots);
     
              });
        }


        if(this._DataProvider.Muzeum.settings.type == 'multiExe'){
          if(res.length > 1){

            res = res.sort((a, b) => a["order"] - b["order"]);
          }
          
          
          this.Exhibitions = res;
          this.multiExe = true;
          // get spost
          let self = this;
          console.log('this.id--:',this.id);
          this.oneExID = res[0].id;
          console.log('this.oneExID--:',this.oneExID);

          this._DataProvider.getSpotsByExhibitionIDFB(this.oneExID)
          .subscribe(res => {
            console.log(res);
            self.spots = res;
            self._DataProvider.spotsList = res;
            self.loaderPage = true;
            setTimeout(() => {
              self.loaderPageDisplayNone = true;
            }, 1300);
        console.log(self.spots);
     
              });
        }
          this.loaderPage = true;
          setTimeout(() => {
            this.loaderPageDisplayNone = true;
          }, 1300);

    console.log(this.Exhibitions);
    console.log(this.MuzeumData);
    console.log(this.muzeum);
    console.log(this.lang);

          });
    });
  }



    // this._DataProvider.getMuzeumByurlCode(this.muzeum)
    // .subscribe(res => {
    //   console.log(res["theResult"][0]);
    //   this._DataProvider.Muzeum = res["theResult"][0];

    //   this.MuzeumData = this._DataProvider.getMuzeumData(this.lang);

    //   this._DataProvider.getExhibitionByLang(this._DataProvider.Muzeum._id,this.lang)
    //   .subscribe(res => {
    //     console.log(res["theResult"]);
    //     this.Exhibitions = res["theResult"];
    //     this._DataProvider.ExhibitionsService= res["theResult"];
    // console.log(this.Exhibitions);
    // console.log(this.MuzeumData);
    // console.log(this.muzeum);
    // console.log(this.lang);

    //       });
    //     });



    
 



        

    // Put here the code you want to execute
  }




  goToExlist(exid){
  
  
    console.log('this.Exhibitions[0]',exid);
    console.log('this.muzeum',this.muzeum);
   this._DataProvider.selectedExebition = exid;
   this._DataProvider.setLocalStorage('exhibitionID',exid);

    this.navCtrl.push(ExhibitionListPage, {
      muzeum:this.muzeum,
      exid:exid

    })
   }


  gotoSpot(item){
    console.log(item);
    this._DataProvider.selectedSpotExe = item.id;
    console.log(this._DataProvider.selectedSpotExe);
    console.log(this.muzeum);
    this._DataProvider.setLocalStorage('selectedSpotID',this._DataProvider.selectedSpotExe);
    this.navCtrl.push(SpotPage, {
      muzeum:this.muzeum
      // id:this._DataProvider.selectedSpot._id,
      // exhibition:this.id,

    })

  }

  enterSpotsList(select){
    SpotsListPage
    this._DataProvider.selectedExebition = select;
    this._DataProvider.setLocalStorage('exhibitionID',select.id);
    this._DataProvider.setLocalStorage('spotType',select.spotType);
    this.navCtrl.push(SpotsListPage, {
      muzeum:this.muzeum,
    })

  }

  enterExhibitionGlobal(){
    console.log('this.Exhibitions[0]',this.Exhibitions[0]);
    console.log('this.muzeum',this.muzeum);
   this._DataProvider.selectedExebition = this.Exhibitions[0];
   this._DataProvider.setLocalStorage('exhibitionID',this.Exhibitions[0].id);

    this.navCtrl.push(ExhibitionPage, {
      muzeum:this.muzeum,
    })
  }
  

  goToCode(){

  

   this._DataProvider.selectedExebition = this.Exhibitions[0];
   this._DataProvider.setLocalStorage('exhibitionID',this.Exhibitions[0].id);
   this._DataProvider.setLocalStorage('spotType',this.Exhibitions[0].spotType);


    this.navCtrl.push(ExhibitionPage, {
      muzeum:this.muzeum,
    })
  }
  enterExhibition(select){
    console.log(select);
    this._DataProvider.selectedExebition = select;
    this._DataProvider.setLocalStorage('exhibitionID',select.id);
    this._DataProvider.setLocalStorage('spotType',select.spotType);

    this.navCtrl.push(ExhibitionPage, {
      muzeum:this.muzeum,
    })

  }

  goBack(){
    setTimeout(() => {
      this.navCtrl.setRoot(MuzeumPage, {
        muzeum: this.muzeum,
      })
    }, 200);
  }

  ulClass(){
    if(this.MuzeumData.ExhibitionStyle == 'option2'){
      return true;
    }else{
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/muzeum/muzeum.ts